/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><es-overlay :show="(option.show)" position="fade" v-if="(option.overlay)"/><es-transition :show="(option.show)" :custom-class='("es-toast custom-class "+(isText && "es-toast--text"))' name="center"><div class="es-toast__icon" v-if="(option.name)"><es-icon :name="(option.name)"></es-icon></div><div class="es-toast__text">{{option.message}}</div></es-transition></div></template>

/* styles */
<style lang="stylus" src="./style.styl" mpxStyleOptions='{"mid":"m68e47551"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m68e47551"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex68e47551%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex68e47551%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m68e47551"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index68e47551/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-overlay':getComponent(require("../overlay/index.mpx?isComponent&outputPath=components%2Findex3774078c%2Findex")),'es-transition':getComponent(require("../transition/index.mpx?isComponent&outputPath=components%2Findex0d073e82%2Findex")),'es-icon':getComponent(require("../icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
